"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _dateformart = require("@/utils/dateformart");

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "log:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['userTypeEnums'])),
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        operator: "",
        userType: "",
        operationTime: [(0, _dateformart.getTodayBegin)(), (0, _dateformart.getNowLessOneSecond)()],
        operationDescription: ""
      },
      showReviewer: false,
      downloadLoading: false,
      multipleSelection: []
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    convertUserTypeName: function convertUserTypeName(name) {
      var found = "";
      this.userTypeEnums.forEach(function (status) {
        if (status.key == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    getList: function getList() {
      var _this = this;

      var params = this.getQueryParams();
      this.listLoading = true;

      _httpUtils.default.post("log", "list", null, params).then(function (res) {
        //let index;
        _this.list = res.data.rows;
        _this.total = res.data.total;
      });

      setTimeout(function () {
        _this.listLoading = false;
      }, 1 * 1000);
    },
    getQueryParams: function getQueryParams() {
      if (this.queryParameter.operationTime == null) {
        return {
          pageNum: this.queryParameter.pageNum,
          pageSize: this.queryParameter.pageSize,
          username: this.queryParameter.operator,
          userType: this.queryParameter.userType,
          createTimeFrom: (0, _dateformart.getTodayBegin)(),
          createTimeTo: (0, _dateformart.getNowLessOneSecond)(),
          operation: this.queryParameter.operationDescription
        };
      } else {
        return {
          pageNum: this.queryParameter.pageNum,
          pageSize: this.queryParameter.pageSize,
          username: this.queryParameter.operator,
          userType: this.queryParameter.userType,
          createTimeFrom: this.queryParameter.operationTime[0],
          createTimeTo: this.queryParameter.operationTime[1],
          operation: this.queryParameter.operationDescription
        };
      }
    },
    handleFilter: function handleFilter() {
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;